
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomahabaleshwarinnovacab() {



    const cardData =
    {
        keyword: 'Pune to Mahabaleshwar Innova Crysta Cab',
        heading: 'Meghana Cab : Pune to Mahabaleshwar Innova Crysta Cab',
        headingDescription: 'Meghana Cab offers Pune to Mahabaleshwar Innova Crysta Cab, perfect for those seeking a luxurious, roomy, and scenic drive to the lush hill station. Our Innova Crysta vehicles feature classy leather interiors, plush seating, and spacious luggage compartments—ideal for family getaways, group outings, or weekend escapes. Enjoy a comfortable ride through the Western Ghats with experienced, courteous chauffeurs who know the best routes and viewpoints. Benefit from transparent fixed pricing, door-to-door service, and 24/7 customer support. Book your Pune to Mahabaleshwar Innova Crysta Cab with Meghana Cab and travel in style, comfort, and reliability for an unforgettable mountain trip.',


        top: 'Top Places to Visit in Mahabaleshwar with Meghana Cab',

"topPlaces": [
  {
    "title": "Wilson Point (Sunrise Point)",
    "description": "Wilson Point is the highest point in Mahabaleshwar, situated at an elevation of 1,439 meters (4,721 feet) above sea level. It is famously known as the Sunrise Point, offering breathtaking panoramic views of the hills and valleys as the sun rises above the Sahyadri mountain range. The plateau has three towers and 360-degree views, making it an ideal place for early morning trekkers, photographers, and nature lovers. On clear days, one can see vast expanses of greenery, dense forests, and distant peaks glowing in golden light."
  },
  {
    "title": "Venna Lake",
    "description": "Spread across 28 acres, Venna Lake is a picturesque man-made lake surrounded by lush greenery and tall trees. It was constructed in 1842 by Shri Appasaheb Maharaj, the ruler of Satara. Popular for boating, horse riding, and paddle boating, it’s a favorite among families and couples. The lake is lined with stalls offering snacks like corn, strawberries, and roasted peanuts, adding to the local charm. The cool breeze, reflective waters, and nearby garden make it a relaxing and scenic spot to unwind."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "This viewpoint is named for its unique rock formation resembling the head of an elephant with a trunk. Perched on the cliffs of the Western Ghats, it offers majestic views of the Sahyadri valleys and the Koyna River meandering far below. The site is also ideal for misty monsoon visits and peaceful reflection. It is located close to Kate’s Point and provides one of the best spots for landscape photography, especially at sunrise and sunset when the fog rolls in over the hills."
  },
  {
    "title": "Pratapgad Fort",
    "description": "About 21 km from Mahabaleshwar, Pratapgad Fort is a historical marvel built in 1656 by Chhatrapati Shivaji Maharaj. It is famously associated with the Battle of Pratapgad, where Shivaji defeated the Bijapur general Afzal Khan. The fort has four lakes, ancient watchtowers, and a Bhavani Mata temple at its summit. Offering stunning views of the Konkan coastline and surrounding hills, the fort is a popular trekking and heritage destination. Guides are available to narrate tales of Maratha valor and strategy."
  },
  {
    "title": "Arthur’s Seat",
    "description": "Often called the ‘Queen of All Points’, Arthur’s Seat is the most famous viewpoint in Mahabaleshwar, offering a dramatic view of the deep Savitri gorge on one side and lush green valleys on the other. The point is named after Sir Arthur Malet, who used to sit here in memory of his deceased wife and daughter. The unique feature here is the floating of light objects due to air pressure—a phenomenon tourists love to test. A series of points along the trail, like Echo Point and Tiger Spring, add to the overall experience."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Located about 6 km from Mahabaleshwar town, Lingmala Waterfall is a two-tiered cascade that plunges from a height of 600 feet. The main waterfall is a thrilling sight, especially during monsoon when it is in full force, creating a roaring misty drop. A smaller waterfall nearby is accessible for those wanting to dip their feet. A short trek through forested paths leads to the falls, making it a favorite spot for nature lovers, photographers, and those looking for a serene picnic location."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a lush green campus located on the Panchgani-Mahabaleshwar road, famous for its strawberry plantations, chocolate factory, and refreshing strawberry-based treats. Visitors can enjoy strawberry shakes, sandwiches, pizzas, and the famous strawberry-with-cream dessert. The garden also has a retail outlet selling squashes, jams, crushes, and preserves. With its floral walkways, open-air seating, and weekend crowd, Mapro Garden is not just a food destination but a full family-friendly attraction."
  },
  {
    "title": "Panch Ganga Temple",
    "description": "Situated at the confluence of five rivers—Krishna, Venna, Koyna, Savitri, and Gayatri—the Panch Ganga Temple is a revered pilgrimage site built in the 13th century. The temple features traditional Hemadpanthi architecture with intricate stonework and a sacred spout (Gaumukh) from which water flows continuously. Believed to be spiritually potent, the site attracts thousands of devotees, especially during festivals. Located near Mahabaleshwar Temple, it forms part of the region’s spiritual circuit."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "This ancient temple dedicated to Lord Shiva is believed to be over 500 years old and holds great mythological and religious significance. Built in the Hemadpanthi style, the temple houses the sacred ‘Swayambhu’ (self-originated) lingam made of black stone. The inner sanctum also holds a trishul and damru attributed to Lord Shiva. It is a major spiritual attraction, drawing devotees and architecture enthusiasts alike. The tranquil surroundings enhance the meditative and devotional experience."
  },
  {
    "title": "Kate’s Point",
    "description": "Named after the daughter of British Governor Sir John Malcolm, Kate’s Point offers a commanding view of the Krishna Valley, Dhom Dam, and the surrounding greenery. Located about 15 km from the town, it includes multiple viewpoints like Echo Point and Needle Hole Point. The vast scenic expanse, cool winds, and photo-worthy angles make it a hit with tourists year-round. Ideal for morning visits, this site is a visual treat and a great stop on any Mahabaleshwar sightseeing itinerary."
  }
],

"services": [
  {
    "name": "Pune to Mahabaleshwar Innova Crysta Cab Booking",
    "description": "Book your Innova Crysta cab for a comfortable and scenic journey from Pune to Mahabaleshwar. Our service ensures a hassle-free ride with well-maintained vehicles, professional chauffeurs, and timely pickups, making your hill station trip relaxing and enjoyable."
  },
  {
    "name": "One Way Innova Crysta Pune to Mahabaleshwar",
    "description": "Choose our one-way Innova Crysta service from Pune to Mahabaleshwar for a convenient and direct trip. Ideal for travelers seeking flexibility and comfort without the need for a return ride, this service guarantees a smooth, air-conditioned journey with ample luggage space."
  },
  {
    "name": "Round Trip Innova Crysta Pune Mahabaleshwar",
    "description": "Plan a seamless round trip from Pune to Mahabaleshwar and back with our Innova Crysta cabs. Perfect for weekend getaways, family outings, or corporate retreats, enjoy luxury seating, professional driving, and flexible scheduling tailored to your itinerary."
  },
  {
    "name": "AC Innova Crysta Taxi Pune to Mahabaleshwar",
    "description": "Beat the heat with our fully air-conditioned Innova Crysta taxi service from Pune to Mahabaleshwar. Travel in style and comfort with climate control, plush interiors, and smooth suspension, ensuring a pleasant and refreshing ride throughout your journey."
  },
  {
    "name": "Family Innova Crysta Trip Pune to Mahabaleshwar",
    "description": "Make your family trip memorable and stress-free with our spacious Innova Crysta cabs for Pune to Mahabaleshwar travel. Designed to accommodate groups with ample legroom and luggage capacity, this service offers safety, comfort, and convenience for family travelers."
  },
  {
    "name": "Budget Innova Crysta Cab Pune to Mahabaleshwar",
    "description": "Experience affordable luxury with our budget-friendly Innova Crysta cab service from Pune to Mahabaleshwar. Ideal for travelers who want comfort and reliability without overspending, our competitive pricing ensures excellent value for your journey."
  },
  {
    "name": "Chauffeur Driven Innova Crysta Pune to Mahabaleshwar",
    "description": "Relax and enjoy your trip to Mahabaleshwar with our professional chauffeur-driven Innova Crysta service from Pune. Our experienced drivers prioritize your safety and punctuality, offering a smooth, stress-free travel experience."
  },
  {
    "name": "Private Innova Crysta Pune Mahabaleshwar",
    "description": "Hire a private Innova Crysta cab for exclusive travel between Pune and Mahabaleshwar. Perfect for travelers seeking privacy and personalized service, this option ensures a dedicated vehicle and driver for your convenience."
  },
  {
    "name": "Online Booking Innova Crysta Pune to Mahabaleshwar",
    "description": "Easily book your Innova Crysta cab online for Pune to Mahabaleshwar trips. Our user-friendly platform offers instant booking confirmation, secure payments, and flexible scheduling to suit your travel plans."
  }
],
"tableData": [
  ["Pune to Mahabaleshwar Innova Crysta Cab Booking", "One Way Innova Crysta Pune to Mahabaleshwar"],
  ["Round Trip Innova Crysta Pune Mahabaleshwar", "AC Innova Crysta Taxi Pune to Mahabaleshwar"],
  ["Family Innova Crysta Trip Pune to Mahabaleshwar", "Budget Innova Crysta Cab Pune to Mahabaleshwar"],
  ["Chauffeur Driven Innova Crysta Pune to Mahabaleshwar", "Private Innova Crysta Pune Mahabaleshwar"],
  ["Online Booking Innova Crysta Pune to Mahabaleshwar", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Mahabaleshwar Innova Crysta Cab",
        "WhyChoosedescription": "Travel from Pune to Mahabaleshwar in style and comfort with our Innova Crysta cab service. Enjoy a smooth ride in a spacious, air-conditioned vehicle that perfectly suits family trips, group outings, and leisure travel to the hill station."
    },
    {
        "WhyChooseheading": "Spacious and Luxurious Interiors",
        "WhyChoosedescription": "The Innova Crysta offers ample legroom, ergonomic seating, and premium interiors, ensuring a relaxing journey even on the winding roads to Mahabaleshwar. It comfortably accommodates up to 6-7 passengers along with luggage."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with the Route",
        "WhyChoosedescription": "Our skilled drivers know the best and safest routes from Pune to Mahabaleshwar, ensuring timely arrivals and a smooth journey. Their experience on hilly terrains guarantees your safety and comfort throughout the trip."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "Each Innova Crysta in our fleet is regularly serviced, cleaned, and sanitized before every trip. We prioritize vehicle hygiene and maintenance to provide a safe and pleasant travel environment."
    },
    {
        "WhyChooseheading": "Flexible Booking and Custom Itineraries",
        "WhyChoosedescription": "Book your Innova Crysta for one-way or round trips, day tours, or multi-day excursions. Customize your pickup and drop-off times, stops en route, and travel duration to match your plans perfectly."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our fares are clear and all-inclusive, covering fuel, tolls, taxes, and driver allowances. We offer competitive pricing for premium service without any surprise costs."
    },
    {
        "WhyChooseheading": "Ideal for Family Vacations and Group Travel",
        "WhyChoosedescription": "Whether you’re traveling with family or friends, our Innova Crysta cabs provide the space and comfort needed for an enjoyable trip to the beautiful hill station of Mahabaleshwar."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Booking",
        "WhyChoosedescription": "Our customer support team is available around the clock to assist you with bookings, itinerary changes, or any special requests, ensuring a hassle-free travel experience."
    }
]


















    }

const faqData = [
    {
        question: "How can I book an Innova Crysta cab from Pune to Mahabaleshwar?",
        answer: "You can book your cab by calling Meghana Cab at +91 9075462128 or using our website for fast online booking."
    },
    {
        question: "What is the travel time from Pune to Mahabaleshwar by Innova Crysta?",
        answer: "The drive typically takes around 3.5 to 4.5 hours, depending on traffic and weather conditions."
    },
    {
        question: "Is the Innova Crysta suitable for hilly terrain like Mahabaleshwar?",
        answer: "Yes, the Innova Crysta is ideal for hill station trips, offering power, comfort, and stability on winding roads."
    },
    {
        question: "Can I book the Innova Crysta for a round trip from Pune to Mahabaleshwar?",
        answer: "Absolutely. Round trip and one way options are both available based on your travel plan."
    },
    {
        question: "Is the Innova Crysta cab service available 24/7 from Pune to Mahabaleshwar?",
        answer: "Yes, Meghana Cab provides 24/7 cab services so you can travel at your convenience."
    },
    {
        question: "What is included in the fare for Pune to Mahabaleshwar Innova Crysta cab?",
        answer: "The fare includes driver charges, fuel, and tolls. Waiting or parking charges may be additional if applicable."
    },
    {
        question: "Is the Innova Crysta sanitized before every trip?",
        answer: "Yes, we thoroughly sanitize the vehicle before every journey to ensure passenger safety."
    },
    {
        question: "Can we request sightseeing stops in Mahabaleshwar?",
        answer: "Yes, sightseeing can be arranged. Please mention your plan at the time of booking."
    },
    {
        question: "How many people can travel in an Innova Crysta cab?",
        answer: "The Innova Crysta can comfortably accommodate up to 6 or 7 passengers."
    },
    {
        question: "What are the payment options available for booking?",
        answer: "We accept UPI, credit/debit cards, online banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Shrikant Pawar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Took an Innova Crysta to Mahabaleshwar with Meghana Cab. Clean vehicle, smooth ride, and a very professional driver.”',
    },
    {
        name: 'Ms. Rutuja Apte',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent experience! The Innova Crysta was perfect for our weekend getaway to Mahabaleshwar.”',
    },
];







































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Mahabaleshwar Innova Crysta Cab Service",
  "description": "Book Innova Crysta cab from Pune to Mahabaleshwar for one way or round trips. Comfortable, AC, chauffeur-driven rides available for family and private travel with online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Mahabaleshwar"
    }
  ],
  "serviceType": "Innova Crysta Cab Booking",
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-mahabaleshwar-innova-crysta-cab"
  }
};








    return (
        <div>

<Helmet>
  <title>Pune to Mahabaleshwar Innova Crysta Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Innova Crysta cab from Pune to Mahabaleshwar for one way or round trips. Comfortable, AC, chauffeur-driven rides for family and private travel. Online booking available." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mahabaleshwar Innova Crysta Cab Booking, One Way Innova Crysta Pune to Mahabaleshwar, Round Trip Innova Crysta Pune Mahabaleshwar, AC Innova Crysta Taxi Pune to Mahabaleshwar, Family Innova Crysta Trip Pune to Mahabaleshwar, Budget Innova Crysta Cab Pune to Mahabaleshwar, Chauffeur Driven Innova Crysta Pune to Mahabaleshwar, Private Innova Crysta Pune Mahabaleshwar, Online Booking Innova Crysta Pune to Mahabaleshwar" 
  />
  <script type="application/ld+json">
    {JSON.stringify(serviceSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/81.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomahabaleshwarinnovacab;